'use client'
import React from 'react'

import HeaderTopbarAddressShippingSwitcher from '@maestro/commerce-blocks/components/header-topbar/header-topbar-address-shipping-switcher'
import HeaderTopbarCompanySwitcher from '@maestro/commerce-blocks/components/header-topbar/header-topbar-company-switcher'
import HeaderTopbarMenu from '@maestro/commerce-blocks/components/header-topbar/header-topbar-menu'
import HeaderTopbarUserInfo from '@maestro/commerce-blocks/components/header-topbar/header-topbar-user-info'
import { theme } from '@maestro/local/theme'

import '@maestro/commerce-blocks/components/header-topbar/styles/header-topbar.scss'

const HeaderTopbar = () => {
  const {
    header: {
      companySwitcherType,
      isCompanySwitcherEnabled,
      isShippingAddressSwitcherReady,
      isEnabledUserInfo,
    },
  } = theme()

  return (
    <div className="header-topbar">
      <div className="header-topbar__container">
        <div className="header-topbar__content">
          <div className="desktop-only">
            <HeaderTopbarMenu />
          </div>
          <div className="header-topbar__controls">
            {isEnabledUserInfo && <HeaderTopbarUserInfo />}
            {isCompanySwitcherEnabled &&
              (companySwitcherType === 'shippingAddress' ? (
                isShippingAddressSwitcherReady && (
                  <HeaderTopbarAddressShippingSwitcher />
                )
              ) : (
                <HeaderTopbarCompanySwitcher />
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderTopbar
